import { render, staticRenderFns } from "./Announcements.vue?vue&type=template&id=370cd5ba&scoped=true&"
import script from "./Announcements.vue?vue&type=script&lang=js&"
export * from "./Announcements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370cd5ba",
  null
  
)

export default component.exports